import { render, staticRenderFns } from "./LessonMaterials.vue?vue&type=template&id=6abdcb84&scoped=true&"
import script from "./LessonMaterials.vue?vue&type=script&lang=js&"
export * from "./LessonMaterials.vue?vue&type=script&lang=js&"
import style0 from "./LessonMaterials.vue?vue&type=style&index=0&id=6abdcb84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6abdcb84",
  null
  
)

export default component.exports